import { ShaderModule } from '@luma.gl/shadertools';

export default {
    name: 'ishiddable',
    inject: {
        'vs:#decl': `
          in float isHidden;
        `,
        'vs:#main-start': `
          if(isHidden > 0.0 ) {
            return;
        }
        `
    }
} satisfies ShaderModule;
